import React from 'react';
import './Week06.scss';

import Question from '../lessonComponents/Question/Question';
import Paragraph from '../lessonComponents/Paragraph/Paragraph';
import Title from '../lessonComponents/Title/Title';
import LessonHeader from '../lessonComponents/LessonHeader/LessonHeader';

const Week06 = () => (
  <div className="Week06" data-testid="Week06">
    <LessonHeader image="https://images.unsplash.com/photo-1557148353-009729a39979?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80"
                  week="6 НЕДЕЛЯ"
                  title="СЛОМЛЕННОСТЬ"/>

    <Paragraph>
      Название этой темы может показаться странной для тех людей, 
      которые никогда не применяли это слово к христианской жизни. Сломленность. 
      Это слово вызывает в нас негативные чувства. Никто не хочет быть сломлен. На этой неделе, 
      мы постараемся понять, что сломленность — это хорошо!
    </Paragraph>

    <Title>РАСПРОСТРАНЕННАЯ ПРОБЛЕМА</Title>
    <Paragraph>
      Многие христиане упускают близость в отношениях с Господом, которую они могли бы иметь. 
      Только слегка прикоснувшись к Нему и Его Слову, они удивляются, 
      почему не испытывают полноты Духа Святого и радости от жизни с Ним. Они ограничили свою 
      близость в отношениях и не могут принести много плода. Проводя поверхностную христианскую жизнь, 
      они видят в Библии обещания и благословения, но игнорируют трудности, 
      о которых также говорит Писание. Из-за того, что им не хватает реальных отношений 
      с Богом, они пытаются заменить их эмоциональностью. Они имитируют близость с Иисусом, 
      ища сильных чувств и мурашек по коже. Они остаются в таком состоянии, не желая глубже узнавать Господа и Его пути.
    </Paragraph>

    <Paragraph>
      Другие христиане смогли избежать этой сухости, решительно познавая Бога в их жизнях. 
      Они хотят прославлять Его и приносить Ему плод. Стремление знать Бога ближе заставляет 
      их все больше искать Его. Если вы относите себя ко второй категории людей, читайте дальше, 
      как можно добиться большей глубины в отношениях с Богом.
    </Paragraph>

    <Title>РАБОТА БОГА В НАС</Title>

    <Paragraph>
      Бог берет людей, кто посвящен Ему, и ставит их на путь сломленности, 
      и их плодоносность будет им в награду. Характер Иисуса – это и есть наша плодоносность, 
      которая возможна только через работу Духа Святого в нас. 
      Когда мы позволяем Богу разбираться с нашим характером, тогда мы сможем принести много плода.
    </Paragraph>

    <Question text="От Иоанна 15:8"></Question>
    <Paragraph>Библия иллюстрирует идею сломленности и того, как через нее мы можем больше плодоносить.</Paragraph>
    <Question text="От Иоанна 15:1-2"/>

    <Paragraph>
      Мы так часто удивляемся тому, что, когда мы просим Бога работать в наших жизнях и посвящаем себя 
      любить и слушаться Его, на нашем пути вдруг возникают разные трудности. 
      Почему у Бога все так сложно?! Неужели Он не может наградить Своих верных 
      слуг более спокойной и благословенной жизнью?
    </Paragraph>

    <Paragraph>
      Путь к плодоносности и христоподобию не из легких! Иисус позвал нас следовать за Ним, 
      а затем Он отправился на крест и в могилу. Наше желание познавать Его также ведет нас на крест и в могилу. 
      Многие из нас не задаются целью умирать, но, если мы не примем участие в страданиях Христа 
      через нашу собственную смерть, мы не сможем познать и силу Его воскресения.
    </Paragraph>

    <Question text="Филиппийцам 3:10"/>
    <Paragraph>
      Те, кто впустят смерть, вскоре обретут и воскресение. После воскресения пришел день Пятидесятницы, 
      когда в горнице Отец излил Свой Дух на учеников <b>(Деяния 2)</b>. Эти три события имеют решающее значение: 
      вначале крест и могила, затем воскресение и новая жизнь и, после, Пятидесятница. 
      Часто христиане пытаются перескочить через первое условие, чтобы достичь последних. 
      Но Бог не работает таким образом. Мы берем людей, которые никогда не были на кресте и приводим их сразу в горницу. 
      А потом удивляемся, почему их жизнь так изменчива и в ней нет никакого плода. Они только слегка прикоснулись к Святому Духу, 
      а мы называем их исполненными Им. Это так отличается 
      от жизни первых христиан, которые перевернули весь мир вверх дном.
    </Paragraph>

    <Paragraph>
      Мы сможем быть наполненными Святым Духом ровно настолько, 
      насколько мы даем Ему места в нас. Наша сломленность и сокрушение освобождает внутри нас 
      больше места для Духа. Есть старое и верное изречение: каков твой крест, такова будет и твоя 
      Пятидесятница.
    </Paragraph>

    <Question text="1 Петра 5:6, 10"/>

    <Paragraph>
      Идея о кресте и сломленности непривлекательна для многих христиан сегодня, 
      но это единственный путь к силе и плодоносности. Люди отказываются слушать подобные учения, 
      потому что это неудобно и неприятно для слуха. Проповедники редко проповедуют об этом, 
      потому что люди не желают жестких слов, но это ключ к жизни.
    </Paragraph>

    <Question text="От Иоанна 6:60, 66"/>
    <Question text="2 Тимофею 2:3-4"/>
    <Question text="Исайя 30:10"/>

    <Title>СМЕРТЬ И ЖИЗНЬ</Title>
    <Paragraph>
      Сломленность и сокрушение — это процесс нашей смерти для себя самих, результатом которой будет Божья жизнь, 
      текущая через нас на других. Иисус является величайшим примером этого, и Его ученики, мужья и жены Божьи, 
      на протяжении веков следовали тем же путем.
    </Paragraph>

    <Question text="2 Коринфянам 4:10-12"/>
    <Question text="1 Коринфянам 15:31"/>
    <Question text="От Иоанна 12:24"/>

    <Paragraph>Вот, что должно умереть в нас, как ветви, срезаемые Господом:</Paragraph>
    <Paragraph>
      • Наша своевольная независимоть, которая говорит Богу «нет»<br/>
      • Гордость<br/>
      • Наши амбиции, стремление к успеху с целью сделать себе имя или нажить богатство<br/>
      • Возвышение своих желаний над волей Бога<br/>
      • Уверенность в том, что вы сами сможете превратить себя в лучшего христианина и достичь духовных результатов<br/>
      • Планы, цели и даже мечты, которые противоречат Божьему призванию для вашей жизни<br/>
      • Опора на собственные силы<br/>
      • Одним словом — эгоизм, жизнь, которая вращается вокруг вас, а не вокруг Иисуса.<br/>
    </Paragraph>

    <Paragraph>Следующий стих подводит нас к тому, что мы можем с этим сделать:</Paragraph>

    <Question text="От Луки 9:23"/>
    <Paragraph>
      Что же является крестом в нашей жизни? Мы умираем для себя, когда сближаемся с Богом 
      в самый разгар трудностей: отвержение со стороны тех, кого мы любим, проблемы в 
      семье, болезни, разочарования, когда нас недооценивают, унижения, провалы, принятие 
      неправильных решений или страдание от искушений. Вы можете проходить через разные ситуации: 
      атаки сатаны, последствия своих ошибок, Божью дисциплину и исправление, или вы чувствуете, 
      что запутались и не понимаете, что происходит. Однако, проходя через все это, вы поймете, 
      что во всех ваших обстоятельствах, вы – никто без Бога.
    </Paragraph>

    <Paragraph>
      Вашим крестом могут быть вещи, которые никак не относятся к греху: оставление карьеры, 
      потому что вы услышали призыв стать полноврменным служителем, отказ от комфорта и имущества, 
      потому что вы услышали призыв отдать, уход из безопасности и доверие Богу, отказ исполнять 
      планы и надежды других на вашу жизнь, потому что вы услышали Божьи планы для вас. 
      Суть подобных ситуаций в том, что вы делаете серьезный выбор искать Божьей воли, а не своей собственной 
      и избираете более трудный путь, потому что он будет угоден вашему Господу.
    </Paragraph>

    <Title>ЧТО ТАКОЕ ЭГОИЗМ?</Title>
    <Paragraph>
      Многие книги превозносят эгоизм, который Бог называет грехом. В современной Церкови, 
      наше «Я», которое должно умереть на кресте, под воздействием психологии все еще живет и 
      процветает. Например, распространенный ответ в христианских кругах людям, которые подвержены 
      самосожалению такой: вместо того, чтобы призвать их покаяться, они начинают горевать вместе с ними: 
      «Бедный человек! У тебя было такое трудное детство! Тебе нужно несколько лет восстановления, 
      чтобы научиться любить себя». Иисус никогда не говорил, чтобы мы любили себя. Он говорил, 
      что мы должны любить ближнего, как мы любим самих себя. И если мы будем любить других, 
      как мы уже любим себя, это будет уже хорошо. Самолюбие может возникнуть в результате депрессии 
      или излишней сосредоточенности на самих себе, которое говорит: «Люди не ценят меня, как я этого заслуживаю. 
      Я должен быть в центре внимания!»
    </Paragraph>

    <Question text="От Матфея 22:39"/>
    <Question text="Ефесянам 5:29"/>

    <Paragraph>
      Хотя мир и даже Церковь способствуют утверждению нашего «Я», Бог продолжает говорить, 
      что «Я» должно умиреть. Ценности этого мира в самоуверенности, самостоятельности, 
      самоуважении, самосожалении и самолюбии, и они являются грехом! Единственное с чем согласен Бог — 
      это с самоотречением.
    </Paragraph>

    <Question text="Галатам 5:22-23"/>

    <Paragraph>
      Подобные представления могут шокировать некоторых людей, поэтому, давайте посмотрим внимательнее, 
      что означает самоотречение. В Царстве Божьем совершенно другой подход в достижении целей, 
      чем использует этот мир <b>(Мтф. 20:25-28)</b>. Призыв к самоотречению не означает, 
      что христиане должны быть незаметными, слабыми и боязливыми. Но это значит, что христиане обретают 
      смелость в Боге через веру в Его власть и силу. Вера в Него лучше, чем вера в наши собственные 
      ограниченные возможности. Самодостаточность, самолюбие и самоуверенность не ставят Бога в центре 
      нашей жизни. А если там находимся мы, тогда чья же это жизнь в таком случае?
    </Paragraph>

    <Paragraph>
      Наше «Я» — это бездонная яма. И вместо того, чтобы пытаться заполнить ее хорошими мыслями 
      и чувствами, нам нужно найти нашу ценность в том, как Бог смотрит на нас. 
      Вместо того чтобы сосредотачиваться на себе, поверните свой взгляд к Нему. 
      Вместо стремления к независимости, пусть ваша жизнь будет скрыта в Нем и тогда вы найдете полное удовлетворение 
      и радость. В конечном итоге, всякий эгоизм будет подвергнут суду Божьего Слова.
    </Paragraph>

    <Paragraph>
      Бог разберется со всеми грехами и эгоизмом Вселенной. Добро пожаловать в Божьи владения! 
      Не сопротивляйтесь Ему, когда Он отодвигает ваше «Я» и ставит Иисуса в то место, 
      которого Он достоин, в центр вашей жизни.
    </Paragraph>

    <Title>ПОТОК ЖИЗНИ</Title>

    <Paragraph>
      Смерть и крест – это сложная тема, но помните, что они приносят жизнь. 
      В книге <b>4 Царств 4:8-37</b> записана история пророка, который был исполнен жизни Бога. 
      Однажды женщина, у которой умер сын, пришла к Елисею за помощью. Елисей послал своего слугу Гиезия, 
      чтобы тот воскресил ребенка. Но у него ничего не вышло. У Гиезия не было жизни, которую он мог 
      бы передать мертвому (в следующей главе Бог судит Гиезия за ложь и жадность, посылая ему проказу).
    </Paragraph>

    <Paragraph>
      Тогда Елисей отправился к дому ребенка и распростерся над его телом. 
      Мальчик вернулся к жизни. Этот пророк был настолько наполнен жизнью Бога, 
      что она вытекала из него и касалась других. Смерть мальчика не убила Елисея, 
      но жизнь, которая была у пророка взяла верх над смертью. Елисей был настолько наполнен жизнью, 
      что даже после его смерти, прикосновение его костей вернуло к жизни еще одно мертвое тело <b>(4 Царств 13:21)</b>.
    </Paragraph>

    <Paragraph>
      Этот умирающий мир отчаянно нуждается в воскрешающей жизни Иисуса и силе Святого Духа. 
      Может ли Бог использовать вас, чтобы передать Свою жизнь людям? 
      Выпускаете ли вы из себя Божью жизнь или вы наполняетесь смертью этого мира?
    </Paragraph>

    <Title>ПРЕПЯТСТВИЯ НА ПУТИ К СМЕРТИ ДЛЯ СЕБЯ</Title>
    <Paragraph>
      Когда Иисус был распят, Его враги насмехались над Ним, говоря: «Сойди с креста» <b>(Мтф. 27:40)</b>. 
      Наш враг, дьявол, использует лучшие побуждения людей, чтобы говорить к нам те же слова: «Сойди с креста». 
      Вот, что это может значить сегодня:
    </Paragraph>

    <Paragraph>
      • Не пытайся так сильно трудиться для Бога, ведь другие этого не делают.<br/><br/>
      • Зачем тратить такое ценное свободное время, чтобы читать Библию?<br/><br/>
      • Просто молись перед едой, и не трать часы для молитвы.<br/><br/>
      • Ты уже был в Церкви в прошлое воскресение, а сегодня тебе можно поспать.<br/><br/>
      • Сегодня вечером будет что-то интересное по телевизору. Можно и пропустить скучную молодежную группу!<br/><br/>
      • Зачем ждать, пока мы поженимся, ведь, никто не ждет.<br/><br/>
      • Пусть кто-нибудь другой делает тяжелую работу для Бога.<br/><br/>
      • Молчи, что ты верующий. Ты же не хочешь, чтобы все решили, что ты какой-то странный?<br/><br/>
      • Выбирай легкие пути!<br/><br/>
      Не слушайте эту ложь. Последуйте за теми, кто прошел нелегкий путь Христа перед вами.<br/><br/>
    </Paragraph>

    <Question text="Откровение 12:11"/>

    <Paragraph>Вы следуете этим путем, когда:</Paragraph>
    <Paragraph>
      • Вытаски ваете себя из постели, чтобы молиться и искать Бога раноутром, даже, если вы очень устали <b>(Мк.1:35)</b>.<br/><br/>
      • Поститесь и молитесь, несмотря на урчание в животе <b>(Мтф. 6:16-18)</b>.<br/><br/>
      • Признаете Иисуса публично, рискуя быть отвергнутым, оставляя популярность и желание быть принятым ради Него <b>(Пс. 106:2)</b>.<br/><br/>
      • Отвергаете временное удовольствие греха <b>(Евр. 11:25-26)</b>.<br/><br/>
      • Закрываете дьяволу доступ в свою жизнь <b>(Еф. 4:26)</b>.<br/><br/>
      • Отдаете свои желания брака, карьеры, финансового успеха и достижений в руки Господа и готовы принять низкое место службы, если это то, что Он выбирает для вас <b>(Пс.85:11)</b>.<br/><br/>
      • Отдаете Иисусу право принимать любые решения, живя в полной зависимости от Него <b>(Притчи 3:5-6)</b>.<br/><br/>
      • Живете, постоянно следуя Его воле, а не чьим-то рассуждениям или собственным желаниям <b>(Деяния 20:24)</b>.<br/><br/>
    </Paragraph>

    <Title>МЫ ПОЛАГАЛИСЬ НА СВОИ СИЛЫ</Title>
    <Paragraph>
      Покаяние означает изменение в сознании людей. Человек меняет свои представления о том, 
      что раньше было нормально, а теперь неверно, потому что это противоречит Божьему Слову. 
      Покаяние — это переосмысление наших путей и поворот на пути Божьи. Когда мы сокрушаемся перед Богом – это больше, 
      чем покаяние в грехах. Мы раскаиваемся в том, что полагались на свою плоть, свои собственные силы, 
      а не доверяли Господу.
    </Paragraph>

    <Question text="Псалом 39:5"/>
    <Question text="Римлянам 7:18"/>
    <Paragraph>
      Мы все живем либо по представлениям этого мира: «Ты можешь сделать все», либо по тому, как учит Библия: 
      «Все могу в укрепляющем меня Иисусе Христе» <b>(Фил. 4:13)</b>. Иисус не преувеличивал, когда сказал: 
      «Без Меня не можете делать ничего» <b>(Ин. 15:5)</b>. Невозможно получить духовный рост через плотские дела, 
      даже если они выглядят религиозными.
    </Paragraph>

    <Question text="От Иоанна 3:6"/>
    <Paragraph>
      Что мы можем предложить этому миру? Он не нуждается в большем количестве врачей, юристов или руководителей. 
      В мире их и так много! Но он нуждается во врачах, юристах и руководителях, которые будут наполнены Духом Святым.
    </Paragraph>

    <Question text="2 Коринфянам 4:7"/>
    <Paragraph
      >Миру не нужны наши ученость и сила. Но ему нужно присутствие Бога, которое вытекает из наших жизней. 
      Точно такая же нужда и в христианских кругах. Церковь не нуждается в нашем красивом голосе или способности 
      хорошо говорить. Доводилось ли вам слышать кого-то, кто пел о Боге с большим мастерством, но его песня не касалась 
      вашего сердца. Но может быть, когда-то вы слышали человека не такого способного, но почему-то, когда он пел, 
      вы плакали. Может быть, вы видели проповедников с удивительным знанием греческого и иврита, но без помазания. 
      Можно легко отличить сломленного человека от несломленного. Стоит только оценить, чем наполнена его жизнь и слова – 
      собой или присутствием Бога. Все, что мы можем предложить этому миру и Церкви — это Иисус.
    </Paragraph>

    <Title>КАК БОГ ДЕЛАЕТ НАС СЛОМЛЕННЫМИ?</Title>
    <Paragraph>
      Мы можем не осознавать, что некоторые трудности, с которыми мы встречаемся, — это ответы на наши молитвы. 
      Мы говорили: «Господи! Измени мое сердце, сделай меня похожим на Иисуса. Используй меня». 
      А Бог слышит нас и исполняет, посылая нам разные обстоятельства, чтобы изменить нас в Свой образ.
    </Paragraph>
    
    <Question text="Псалом 118:71"/>

    <Paragraph>
      Процесс ломки для каждого человека различен, но результат сломленности один и тот же. 
      Бог предусмотрел особенное стечение обстоятелств для каждого из вас, направленных на уничтожение вашей 
      эгоцентричной жизни. Никто не сможет пройти это за вас или рассаказать вам более легкий способ преодолеть ваш путь. 
      Никто не сможет предсказать, каким образом Бог будет работать с вами. Так же, как Иаков боролся с Ангелом <b>(Быт. 32:24-26)</b>, 
      так и вам прейдется бороться с Богом один на один. Сломленность – это глубоко личная вещь.
    </Paragraph>

    <Paragraph>
      Бог работает с хирургической точностью. Он никогда не использует чрезмерную силу, 
      и Его Отцовская любовь к вам направляет все Его действия. Иногда вы будете кричать и умолять 
      Его прекратить и оставить вас такими, какие вы есть. Но это действительно то, чего вы хотите? Давайте жить 
      по вере и доверять Ему, что все, что Он делает — это для вашего блага. Как мой друг миссионер как-то сказал: 
      «Самое лучшее образование является и самым дорогим, и только некоторые получают его». Господь дает вам дорогостоящие у
      роки? Если это так, значит Он избрал вас для чего-то особенного. Прекратите спорить и не сдавайтесь!
    </Paragraph>
    
    <Question text="Римлянам 8:28-29"/>

    <Paragraph>
      Когда мы поймем, что Бог делает, мы будем молиться: «Отец, я благодарю Тебя за все, что происходит в моей жизни. 
      Спасибо, что Ты учишь меня не быть независимым, но зависеть от Тебя. Благодарю за смирение, которое 
      разрушает мою гордость, за непринятие и гонения, которые учат меня быть ближе к Тебе. Спасибо за то, 
      что меня недооценивают, ведь я тружусь для славы Бога, а не человека. Спасибо, что Ты меняешь мое сердце, 
      мои мотивы и желания, учишь меня ценить то, что вечно, а не то, что временно».
    </Paragraph>

    <Title>ВОПРОСЫ ПОСЛЕ УРОКА:</Title>
    <Question text="ПослеУрока1">Каким образом Бог ломал вас?</Question>
    <Question text="ПослеУрока2">
      Слышали ли вы идеи о том, что нужно повышать самооценку и хранить свою жизнь для себя, вместо того чтобы 
      отдавать ее? Верили ли вы в это?
    </Question>
    <Question text="ПослеУрока3">Каким образом жизнь Бога течет через вас?</Question>
    <Question text="ПослеУрока4">
      Как враг пытается остановить вас быть сломленными, предлагая «сойти со креста» (Мтф. 27:40)?
    </Question>

    <Title>ВОПРОСЫ В КОНЦЕ НЕДЕЛИ:</Title>
    <Question text="Проверочный1">Каким образом жизнь Бога текла через вас на других на этой неделе?</Question>
    <Question text="Проверочный2">Приведите пример, как вы поставили Божью волю выше своей на этой неделе.</Question>
    <Question text="Проверочный3">Приведите пример того, как вы умерли для себя на этой неделе.</Question>
    <Question text="Проверочный4">Как Господь учил вас не полагаться на свои собственные силы?</Question>
  </div>
);

Week06.propTypes = {};

Week06.defaultProps = {};

export default Week06;
